import { render } from "./OmRadio.vue?vue&type=template&id=d5994b5a"
import script from "./OmRadio.vue?vue&type=script&lang=js"
export * from "./OmRadio.vue?vue&type=script&lang=js"

import "./OmRadio.vue?vue&type=style&index=0&id=d5994b5a&lang=scss"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__